import { useLocation, Navigate } from "react-router-dom";
import redirects from "../../data/redirect.json";
import PageNotFound from "../../containers/PageNotFound/PageNotFound";

const RedirectComponent = ({ children }) => {
  const location = useLocation();
  let currentPath = location.pathname + location.search
  let redirectTo = null;
  console.log('RedirectComponent currentPath', currentPath);
  // Check if any key in the redirects includes the current pathname
  Object.keys(redirects).forEach((redirectKey) => {
    if (redirectKey.includes(currentPath) && currentPath != "/") {
      redirectTo = redirects[redirectKey];
    }
  });

  console.log('RedirectComponent redirectTo', redirectTo);

  if (redirectTo) {
    return <Navigate to={redirectTo} />;
  }

  return <>{children}</>;
};

export default RedirectComponent;
